import React from 'react';
import styles from './ContentF1.scss';
import blockStyles from '@baseStyles/block.scss';
import language from "@lang/language";

const ContentF1 = ({data, color = ''}) => {

	if (!data.blockContent || data.blockContent.length <= 0) {
		return null;
	}

	return (
	  <div className={blockStyles.baseContainerHolder}>
		  <div className={`${blockStyles.baseContainer} ${styles.containerWidth} ${color ? blockStyles[color] : ''}`}>
			  {/* BLOCK TITLE */}
			  {/*///////////////////////////////////////////////////////////////////////////////*/}
			  {data.blockTitle &&
				<h2 className={`${blockStyles.h3} mb24`}>
					{data.blockTitle}
				</h2>
			  }

			  {/* COMPONENT ROWS */}
			  {/*///////////////////////////////////////////////////////////////////////////////*/}
			  <div className={styles.container}>
				  {data.blockContent.map((item, key) => {
					  return (
						<div className={styles.row} key={key}>
							<img
							  src={item.img}
							  alt={item.name}
							  title={item.name + language.shBGTitle}
							  width={96}
							  height={96}
							/>

							<div className={styles.textContainer}>
								<h3
								  className={blockStyles.h4}
								  dangerouslySetInnerHTML={{__html: item.title}}
								/>
								<div className={`${blockStyles.p} ${blockStyles['color-gray-500']}`}>
									{item.name}
								</div>
							</div>
						</div>
					  );
				  })}
			  </div>

			  {/* ALL LINK */}
			  {/*///////////////////////////////////////////////////////////////////////////////*/}
			  <div
				className={`${blockStyles.p} tright`}
				dangerouslySetInnerHTML={{__html: data.allText}}
			  />
		  </div>
	  </div>
	)
}

export default ContentF1;
